 <template>
  <div class="projectPage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入搜索关键词"
      show-action
      shape="round"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" id="list-content">
      <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell
              :title="`${projectItem.objectName}`"
              clickable
              v-for="projectItem in itemMainList"
              :key="projectItem.id"
              @click="selectitem(projectItem)"
            >
              <van-radio slot="right-icon" :name="`${projectItem.objectName}`" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker">取消</a>
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "projectView",
  data() {
    return {
      radio: "", //选中的项目
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      total: "", //统计计算
      itemMainList: [],
      selecItemList: [],
      projectData: {},
      itemId: "",
      Itempage: 0,
      pageSize: 10,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      projectStatus: ["unopen", "win", "failure", "cancel", "suspend", "other"],
      projectType: "",
      clientType: "" //手机类型
    };
  },

  mounted() {
    let winHeight = document.documentElement.clientHeight; //视口大小
    document.getElementById("list-content").style.height =
      winHeight - 95 + "px"; //调整上拉加载框高度
    this.getTest();
  },
  methods: {
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getTest() {
      let _this = this;
      if (_this.Itempage != 0 && this.Itempage * 10 >= parseInt(_this.total)) {
        return;
      }
      _this.Itempage += 1;
      _this.$api.baseCommon.baseMsg.dictBox
        .commonBiddingList(
          {
            pageNum: _this.Itempage,
            pageSize: _this.pageSize,
            objectName: _this.searchKeyword
          },
          _this.projectStatus
        )
        .then(res => {
          if (res.code == "1") {
            _this.total = parseInt(res.data.total);

            _this.selecItemList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;
            if (_this.pageSize * 10 >= _this.total) {
              _this.finished = true;
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.itemMainList = this.itemMainList.concat(this.selecItemList);
    },
    selectitem(item) {
      let _this = this;
      _this.radio = item.objectName;
      _this.itemId = item.id;
    },
    closeRetinuePicker() {
      this.projectData = {};
      this.$emit("setItems", "");
    },
    saveRetinue() {
      let _this = this;
      _this.projectData.id = _this.itemId;
      _this.projectData.name = _this.radio;
      this.$emit("setItems", _this.projectData);
      _this.projectData = new Object();
    },

    reloadPage() {
      this.page = 0;
      this.retinueMainList = [];
      setTimeout(() => {
        this.getTest();
      }, 300);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 300);
    }
  }
};
</script>
<style lang="less" >
.projectPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-content {
    overflow: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    border-top: 1px solid #f6f6f6;
    bottom: 0;
        background-color: #fff;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>